/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=47aaba60&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"
import style0 from "./sign.vue?vue&type=style&index=0&id=47aaba60&prod&lang=scss"
import style1 from "./sign.vue?vue&type=style&index=1&id=47aaba60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aaba60",
  null
  
)

export default component.exports